import React, { useCallback } from 'react';
import { trackUIInteraction } from '../../utils/analyticsEvents';
import linkOut from '@ingka/ssr-icon/paths/link-out';
import Link from '../Link/Link';
import styles from './ExternalLink.module.scss';
import SSRIcon from '@ingka/ssr-icon';

type ExternalLinkProps = {
  asButton?: boolean;
  asIcon?: boolean;
  children?: React.ReactNode;
  href: string;
  label: string;
  text?: string;
};

const ExternalLink = ({
  asButton,
  asIcon,
  children,
  href,
  label,
  text,
}: ExternalLinkProps) => {
  const onClick = useCallback(() => {
    trackUIInteraction('external_link_click', { href, ariaLabel: label });
  }, [href, label]);

  return (
    <Link
      className={asButton ? undefined : styles.link}
      asIcon={asIcon}
      asButton={asButton}
      href={href}
      label={label}
      newWindow
      onClick={onClick}
    >
      {text || children}
      {!asButton && <SSRIcon paths={linkOut} className={styles.icon} />}
    </Link>
  );
};

export default ExternalLink;
